import { FilterOption } from "../../components/Filter";
import { Vehicle } from "../../interfaces";

export function vehiclesToOptions(vehicles: Vehicle[]): FilterOption[] {
  return vehicles.map(({ id, registration }) => ({
    label: registration,
    value: id,
  }));
}
